import type { TFunction } from 'i18next'

/**
 * Trial refusal from the server (one number in total, card required), shown
 * with the same messages as the number marketplace. Null for any other error.
 */
export function trialRefusal(err: unknown, t: TFunction): string | null {
  const code = (err as { response?: { data?: { error?: string } } })?.response?.data?.error
  if (code === 'payment_method_required') return t('manager.numbers.marketplace.paymentMethodRequired')
  if (code === 'trial_limit_reached') return t('manager.numbers.marketplace.trialLimit')
  return null
}
